import { render, staticRenderFns } from "./EditFaqModal.vue?vue&type=template&id=3c83e994&scoped=true&"
import script from "./EditFaqModal.vue?vue&type=script&lang=js&"
export * from "./EditFaqModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83e994",
  null
  
)

export default component.exports